import React, { useState } from 'react';
import { Box, Typography, Button, Card, CardMedia, Grid, Link } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import img1 from './img/custStoryimg1.png';
import img2 from './img/custstoryimg2.png';
import Carousel from './CustomerStoriesCarousel ';

const Customerstory = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const images = [img1, img2];

    const handlePrev = () => {
        setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setCurrentImage((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <>
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #0f172a, #1e3a8a)',
                    backdropFilter: 'blur(10px)',
                    padding: { xs: '20px 10px', sm: '40px 20px' },
                    color: '#fff',
                    minHeight: '400px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    position: 'relative',
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        fontWeight: 'bold',
                        mb: 4,
                        textAlign: 'center',
                    }}
                >
                    Customer stories
                </Typography>

                <Carousel />
            </Box>
        </>

    );
};

export default Customerstory;
